export const ONBOARDING_CHECK_USER_REQUEST = 'ONBOARDING_CHECK_USER_REQUEST';
export const ONBOARDING_CHECK_USER_SUCCESS = 'ONBOARDING_CHECK_USER_SUCCESS';
export const ONBOARDING_CHECK_USER_FAILURE = 'ONBOARDING_CHECK_USER_FAILURE';

export const ONBOARDING_CHECK_ORGANIZATION_REQUEST = 'ONBOARDING_CHECK_ORGANIZATION_REQUEST';
export const ONBOARDING_CHECK_ORGANIZATION_SUCCESS = 'ONBOARDING_CHECK_ORGANIZATION_SUCCESS';
export const ONBOARDING_CHECK_ORGANIZATION_FAILURE = 'ONBOARDING_CHECK_ORGANIZATION_FAILURE';

export const ONBOARDING_ASSIGN_ORGANIZATION_REQUEST = 'ONBOARDING_ASSIGN_ORGANIZATION_REQUEST';
export const ONBOARDING_ASSIGN_ORGANIZATION_SUCCESS = 'ONBOARDING_ASSIGN_ORGANIZATION_SUCCESS';
export const ONBOARDING_ASSIGN_ORGANIZATION_FAILURE = 'ONBOARDING_ASSIGN_ORGANIZATION_FAILURE';

export const ONBOARDING_CREATE_ORGANIZATION_REQUEST = 'ONBOARDING_CREATE_ORGANIZATION_REQUEST';
export const ONBOARDING_CREATE_ORGANIZATION_SUCCESS = 'ONBOARDING_CREATE_ORGANIZATION_SUCCESS';
export const ONBOARDING_CREATE_ORGANIZATION_FAILURE = 'ONBOARDING_CREATE_ORGANIZATION_FAILURE';

export const ONBOARDING_UPDATE_USER_INFO_REQUEST = 'ONBOARDING_UPDATE_USER_INFO_REQUEST';
export const ONBOARDING_UPDATE_USER_INFO_SUCCESS = 'ONBOARDING_UPDATE_USER_INFO_SUCCESS';
export const ONBOARDING_UPDATE_USER_INFO_FAILURE = 'ONBOARDING_UPDATE_USER_INFO_FAILURE';

export const ONBOARDING_ASSIGN_ROLE_REQUEST = 'ONBOARDING_ASSIGN_ROLE_REQUEST';
export const ONBOARDING_ASSIGN_ROLE_SUCCESS = 'ONBOARDING_ASSIGN_ROLE_SUCCESS';
export const ONBOARDING_ASSIGN_ROLE_FAILURE = 'ONBOARDING_ASSIGN_ROLE_FAILURE';

export const ONBOARDING_SET_PREFERENCES_REQUEST = 'ONBOARDING_SET_PREFERENCES_REQUEST';
export const ONBOARDING_SET_PREFERENCES_SUCCESS = 'ONBOARDING_SET_PREFERENCES_SUCCESS';
export const ONBOARDING_SET_PREFERENCES_FAILURE = 'ONBOARDING_SET_PREFERENCES_FAILURE';

export const ONBOARDING_GET_USER_INFO_REQUEST = 'ONBOARDING_GET_USER_INFO_REQUEST';
export const ONBOARDING_GET_USER_INFO_SUCCESS = 'ONBOARDING_GET_USER_INFO_SUCCESS';
export const ONBOARDING_GET_USER_INFO_FAILURE = 'ONBOARDING_GET_USER_INFO_FAILURE';

export const ONBOARDING_REQUEST_JOIN_REQUEST = 'ONBOARDING_REQUEST_JOIN_REQUEST';
export const ONBOARDING_REQUEST_JOIN_SUCCESS = 'ONBOARDING_REQUEST_JOIN_SUCCESS';
export const ONBOARDING_REQUEST_JOIN_FAILURE = 'ONBOARDING_REQUEST_JOIN_FAILURE';

export const ONBOARDING_CLEAR = 'ONBOARDING_CLEAR';
export const ONBOARDING_SET_STEP = 'ONBOARDING_SET_STEP';

export const FETCH_ORG_PEOPLE_REQUEST = 'FETCH_ORG_PEOPLE_REQUEST';
export const FETCH_ORG_PEOPLE_SUCCESS = 'FETCH_ORG_PEOPLE_SUCCESS';
export const FETCH_ORG_PEOPLE_FAILURE = 'FETCH_ORG_PEOPLE_FAILURE';

export interface User {
  id: string;
  auth_id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  organization_id?: string | null;
  role?: string | null;
  is_active: boolean;
  preferences?: Record<string, any>;
  last_login_at?: string;
  created_at: string;
  updated_at?: string;
}

export interface Organization {
  id: string;
  uuid: string;
  name: string;
  type: string;
  email_domain?: string;  // backwards compat
  email_domains?: string[];  
  org_details?: Record<string, any>;  
  parent_id?: string | null;  
}

export interface GeneralSettings {
  language?: string;
  theme?: string;
  currency?: string;
}

export interface AISettings {
  jurisdiction?: string;
  language?: string;
  speaker_voice?: string;
}

export interface Preferences {
  general_settings?: GeneralSettings;
  ai_settings?: AISettings;
}

export interface UserPermissions {
  [key: string]: any;
}

export interface JoinRequest {
  id: string;
  user_id: string;
  organization_id: string;
  status: 'pending' | 'approved' | 'rejected';
  requested_role?: string;
  message?: string;
  created_at?: string;
  reviewed_at?: string;
  review_message?: string;
}

export interface OrgPerson {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  user_id: string;
  name?: string; // Optional, for backward compatibility
  profile_picture?: string | null;
}

export interface OrgPeopleState {
  people: OrgPerson[];
  loading: boolean;
  error: string | null;
}

export interface OnboardingState {
  currentStep: 'welcome' | 'check' | 'organization' | 'user' | 'preferences' | null;
  user: User | null;
  selectedOrganization: Organization | null;
  matchingOrganizations: Organization[];
  newOrganization: Organization | null;
  joinRequest: JoinRequest | null;
  userRole: string | null;
  userFirstName: string | null;
  userLastName: string | null;
  userEmail: string | null;
  preferences: Preferences;
  userPermissions: UserPermissions | null;
  isLoading: boolean;
  error: string | null;
  isComplete: boolean;
  onboardingStatus: 'pending' | 'approved' | 'rejected' | 'completed';
}
